module.exports = __webpack_public_path__ + "static/img/MXLD.2ffa8c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MXLD.png
// module id = 6Mms
// module chunks = 34